<template>
  <div>

    <b-modal v-if="event_name" ref="myModalRef" hide-footer hide-header centered>

      <div class="d-block text-center">
        <img :src="event_image" class="event-image" />
      </div>

      <b-button-group size="lg" class="mt25">
        <b-button size="lg" class="custom-bgr-danger" variant="danger" @click="hideModalEvent()">{{$t('event.after')}}</b-button>
        <b-button size="lg" class="custom-bgr-primary" variant="primary" @click="jointEvent()">{{$t('event.join')}}</b-button>
      </b-button-group>

    </b-modal>


    <!--<base-header></base-header>-->
    <div class="container">

      <div class="text-center mt10 mb30">
        <img src="/static/ccall.png" class="logo-ccall" width="200" />
      </div>

      <form @submit.prevent="register">
        <div class="form-header" v-if="!token">
          {{$t('register.header')}}
        </div>
        <div v-else>
          <div class="form-header">{{$t('register.accountCreationSuccessfully')}}</div>
          <p>{{$t('register.accountJustCreatedSuccessfully')}}</p>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="name" :placeholder="$t('register.name')" :class="{'form-error': errorMessage['name']}" :disabled="token" />
          <p v-for="msg in errorMessage['name']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="phone" :placeholder="$t('register.phone')" :class="{'form-error': errorMessage['phone']}" :disabled="token"  />
          <p v-for="msg in errorMessage['phone']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="email" class="form-control" v-model="email" :placeholder="$t('register.email')" :class="{'form-error': errorMessage['email']}" :disabled="token"  />
          <p v-for="msg in errorMessage['email']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group text-center term-checkbox" v-if="!token">
          <label>
            <input type="checkbox" v-model="agree" :disabled="token" /> {{$t('register.agree')}}

            <!--<router-link :to="{name: 'PolicyPage'}">{{$t('register.term')}}</router-link>-->

            <a href="#" @click="gotoPolicy()">{{$t('register.term')}}</a>

           </label>
          <p v-for="msg in errorMessage['agree']" class="text-error">{{msg}}</p>
        </div>
        <div class="text-help" v-else>{{$t('register.toLoginTouchOK')}}</div>

        <p class="text-help-call" v-if="token">
          {{$t('register.trialCallQuality')}}
        </p>

        <div class="form-group text-center btn-submit">
          <base-button type="submit" class="btn-block" v-if="!token" :disabled="name.length ==0 || phone.length == 0 || email.length == 0 || !agree || isDisabled">{{$t('register.register')}}</base-button>
          <base-button type="submit" class="btn-block" v-else>OK</base-button>
        </div>

      </form>

      <p class="text-footer" v-if="!token">
        {{$t('register.haveAccount')}} <router-link :to="{name: 'LoginPage'}">{{$t('register.login')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import Slide from '../components/Slide';
import BaseButton from "../components/Button.vue";
import BaseHeader from "../components/Header.vue";

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import bButton from 'bootstrap-vue/es/components/button/button';
import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('b-modal', bModal);
Vue.directive('b-modal', bModalDirective);
Vue.component('b-button', bButton);
Vue.component('b-button-group', bButtonGroup);

export default {
  components: {
    BaseHeader,
    BaseButton,
    Slide,
  },
  name: 'RegisterPage',
  props: {
    token: [Number, String],
    event_name: [String],
    nameInput: [String],
    emailInput: [String],
    phoneInput: [String],
    agreeInput: [Boolean]
  },
  data() {
    return {
      name: this.nameInput ? this.nameInput : '',
      email: this.emailInput ? this.emailInput : '',
      phone: this.phoneInput ? this.phoneInput : '',
      agree: this.agreeInput ? this.agreeInput : false,
      errorMessage: [],
      isDisabled: false,
      event_image: this.event_name ? this.event_name : ''
    };
  },
  methods: {
    register() {
      if (this.token) {
        localStorage.setItem('token', this.token);
        top.window.location.href = localStorage.getItem('url');
        setTimeout(() => {
          this.$router.push({name: 'EditPage'});
        }, 100);
        return;
      }
      this.isDisabled = true;
      this.errorMessage = [];
      const bodyFormData = new FormData();
      bodyFormData.append('name', this.name);
      bodyFormData.append('email', this.email);
      bodyFormData.append('phone', this.phone);
      bodyFormData.append('agree', this.agree);
      this.axios.post('/register', bodyFormData).then((response) => {
         if ((response.data.status)) {
           this.$router.push({name:'VerifyPage', params: {token: response.data.data.token, phone: response.data.data.phone}});
         } else {
           this.errorMessage = response.data.data;
           this.isDisabled = false;
         }
      });
    },
    hideModalEvent () {
      this.$refs.myModalRef.hide();
    },
    jointEvent () {
      if (this.token) {
        this.axios.post('/userJoinEvent?token='+this.token).then((response) => {});

        localStorage.setItem('token', this.token);
        top.window.location.href = localStorage.getItem('url');
        setTimeout(() => {
          this.$router.push({name: 'EditPage'});
        }, 100);
        return;
      }
    },
    gotoPolicy() {
      this.$router.push({name:'PolicyPage', params: {name: this.name, phone: this.phone, email: this.email, agree: this.agree}});
    }
  },
  mounted() {

    this.name = this.nameInput ? this.nameInput : "";
    this.email = this.emailInput ? this.emailInput : "";
    this.phone = this.phoneInput ? this.phoneInput : "";
    this.agree = this.agreeInput ? this.agreeInput : false;

    const token = localStorage.getItem('token');
    if (token) {
      this.$router.push({name: 'EditPage'});
    }

    if(this.event_name) {
      this.event_image = "/static/event_image/" + this.event_name;
      this.$refs.myModalRef.show()
    }

    if (this.token) {
      this.axios.get('/getData?token=' + this.token).then((response) => {
        if ((response.data.status)) {
          this.name = response.data.data.name;
          this.email = response.data.data.email;
          this.phone = response.data.data.phone;
        } else {
          this.$router.push({name: 'RegisterPage'});
        }
      });
    }
  }
};
</script>

<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/RegisterPage.vue